import { Button, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';
import TableHeader from '../../../../../theme/components/TableHeader/TableHeader';
import styles from '../BeneficiosMGM.style';
import { INITIAL_FILTER_STATE } from '../BeneficiosMGMTableConstants';

const useStyles = makeStyles(styles);

export const BeneficiosMGMParametrosHeader = props => {
  const { filters, setFilters } = props;
  const classes = useStyles(props);

  const clearFiltersDisabled = Object.values(filters).filter(fil => fil != null).length === 0;

  return (
    <TableHeader.Header>
      <TableHeader.Header.Title>
        <Typography variant="body1">Busca & Filtros</Typography>
      </TableHeader.Header.Title>
      <TableHeader.OptionsLeft>
        <TableHeader.Input>
          <Button
            color="primary"
            className={classes.buttonClearFilter}
            disabled={clearFiltersDisabled}
            onClick={() => setFilters(INITIAL_FILTER_STATE)}
          >
            LIMPAR FILTROS
          </Button>
        </TableHeader.Input>
      </TableHeader.OptionsLeft>
    </TableHeader.Header>
  );
};

BeneficiosMGMParametrosHeader.propTypes = {
  filters: PropTypes.shape({
    contraparte: PropTypes.string,
    distribuidora: PropTypes.string,
    dataFechamento: PropTypes.string,
    parceiro: PropTypes.string,
  }).isRequired,
  setFilters: PropTypes.func.isRequired,
};
